import JobDetails from "./JobDetailsContainer";
export default JobDetails;